import { gql } from "@apollo/client";

export const TERMINATION_SERVICES = gql`
  query terminationServices($where: JSONObject) {
    terminationServices(where: $where)
  }
`;

export const TERMINATION_RECIPIENTS = gql`
  query terminationRecipients($where: JSONObject) {
    terminationRecipients(where: $where)
  }
`;

export const TERMINATION_MOTIFS = gql`
  query terminationMotifs($where: JSONObject) {
    terminationMotifs(where: $where)
  }
`;

const terminations = {
  TERMINATION_SERVICES,
  TERMINATION_RECIPIENTS,
  TERMINATION_MOTIFS,
};

export default terminations;
